import React, {useEffect, useRef, useMemo, memo} from 'react';
import {Props} from './ac-ripple.proptypes';
import clsx from 'clsx';

// Imports => Utilities
import {AcRippleEffect} from '@asdf-utils';

const _CLASSES = {
  MAIN: 'ac-ripple',
  SIMPLE: 'ac-ripple--simple',
  SIZES: {
    DEFAULT: 'ac-ripple--size-default',
    SMALL: 'ac-ripple--size-small',
    MEDIUM: 'ac-ripple--size-medium',
    LARGE: 'ac-ripple--size-large',
    EXTRA_LARGE: 'ac-ripple--size-extra-large',
  },
  THEMES: {
    WHITE: 'ac-ripple--white',
    LIGHT: 'ac-ripple--light',
    SUBTLE: 'ac-ripple--subtle',
    PITCH: 'ac-ripple--pitch',
    ALPHA: 'ac-ripple--alpha',
    ALPHA_LIGHT: 'ac-ripple--alpha-light',
    OMEGA: 'ac-ripple--omega',
    OMEGA_LIGHT: 'ac-ripple--omega-light',
  },
};

const _SIZES = {
  DEFAULT: 5,
  SMALL: 2,
  LARGE: 6,
  EXTRA_LARGE: 10,
};

const AcRipple = memo(
  ({
    target = false,
    size = 'default',
    theme = 'default',
    simple = false,
    fixed = false,
    event = 'click',
    className,
  }) => {
    let $el = useRef(null);
    let ripple = null;

    useEffect(() => {
      initRippleEffect();

      return () => {
        if (ripple) ripple.removeEvents();
      };
    });

    const initRippleEffect = () => {
      const _size = size ? _SIZES[size.toUpperCase()] : 5;

      ripple = new AcRippleEffect($el, target, _size, fixed, event);
    };

    const getStyleClassNames = useMemo(() => {
      return clsx([
        _CLASSES.MAIN,
        theme && _CLASSES.THEMES[theme.toUpperCase()],
        size && _CLASSES.SIZES[size.toUpperCase()],
        simple && _CLASSES.SIMPLE,
        className,
      ]);
    }, [theme, simple, size, className]);

    return <span ref={$el} className={getStyleClassNames} />;
  }
);

AcRipple.displayName = 'AcRipple';
AcRipple.propTypes = Props;

export {AcRipple};
export default AcRipple;
